import { render, staticRenderFns } from "./PickupInfo.vue?vue&type=template&id=0bcd5f0d&scoped=true"
import script from "./PickupInfo.vue?vue&type=script&lang=js"
export * from "./PickupInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcd5f0d",
  null
  
)

export default component.exports